export default (
  text: string,
  style: Partial<CSSStyleDeclaration> = {} as Partial<CSSStyleDeclaration>,
) => {
  let node: HTMLSpanElement | null = document.createElement('span');
  for (const key in style) {
    if (Object.prototype.hasOwnProperty.call(style, key)) {
    // if (style.hasOwnProperty(key)) {
      node.style[key] = style[key] || '';
    }
  }
  node.style.position = 'absolute';
  node.style.left = '-100000000px';
  node.style.top = '-10000000px';
  node.style.zIndex = '-1000';
  document.body.appendChild(node);
  node.innerText = text;

  const width = node.clientWidth;
  document.body.removeChild(node);
  node = null;
  return width;
};
